import { render, staticRenderFns } from "./ChatContentDia.vue?vue&type=template&id=5cc6cb68&scoped=true&"
import script from "./ChatContentDia.vue?vue&type=script&lang=js&"
export * from "./ChatContentDia.vue?vue&type=script&lang=js&"
import style0 from "./ChatContentDia.vue?vue&type=style&index=0&id=5cc6cb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc6cb68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cc6cb68')) {
      api.createRecord('5cc6cb68', component.options)
    } else {
      api.reload('5cc6cb68', component.options)
    }
    module.hot.accept("./ChatContentDia.vue?vue&type=template&id=5cc6cb68&scoped=true&", function () {
      api.rerender('5cc6cb68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/chatChartSupervise/components/ChatContentDia.vue"
export default component.exports